module.exports = __webpack_public_path__ + "static/visa-deals-bg-mobile-586304e4d98b669a814793fda3dcee57.jpg";